<template>
  <div class="not-found-page">
    <div class="content-wrapper">
      <!-- Graphic -->
      <div class="graphic-area">
        <svg
          viewBox="0 0 320 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="graphic-svg"
          aria-hidden="true"
        >
          <!-- Ground shadow -->
          <ellipse cx="160" cy="162" rx="80" ry="10" fill="#e8ede5" />

          <!-- Page body -->
          <rect
            x="90"
            y="30"
            width="140"
            height="130"
            rx="8"
            fill="#f4f7f2"
            stroke="#c8d8c2"
            stroke-width="1.5"
          />

          <!-- Page fold corner -->
          <path d="M204 30 L204 52 L226 52 Z" fill="#c8d8c2" />
          <path d="M204 30 L226 52 H204 Z" fill="#e1eadd" />

          <!-- Lines on page -->
          <rect x="106" y="65" width="60" height="6" rx="3" fill="#c8d8c2" />
          <rect x="106" y="79" width="88" height="5" rx="2.5" fill="#dce8d8" />
          <rect x="106" y="91" width="72" height="5" rx="2.5" fill="#dce8d8" />
          <rect x="106" y="103" width="50" height="5" rx="2.5" fill="#dce8d8" />

          <!-- Big red X circle -->
          <circle
            cx="194"
            cy="112"
            r="28"
            fill="#fff"
            stroke="#e8ede5"
            stroke-width="1.5"
          />
          <circle cx="194" cy="112" r="22" fill="#fde8e8" />
          <path
            d="M183 101 L205 123 M205 101 L183 123"
            stroke="#d84242"
            stroke-width="3.5"
            stroke-linecap="round"
          />

          <!-- 404 label badge -->
          <rect
            x="108"
            y="38"
            width="48"
            height="16"
            rx="4"
            fill="#519043"
            opacity="0.12"
          />
          <text
            x="132"
            y="50"
            text-anchor="middle"
            font-family="'Courier New', monospace"
            font-size="10"
            font-weight="700"
            fill="#3a6b2e"
          >
            404
          </text>
        </svg>
      </div>

      <!-- Text content -->
      <div class="text-area">
        <div class="badge">404</div>
        <h1 class="heading">Page not found</h1>
        <p class="subtext">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <button class="home-btn" @click="redirectTo">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M3 12L12 3l9 9" />
            <path d="M9 21V12h6v9" />
            <path d="M3 12v9h18v-9" />
          </svg>
          Go back to homepage
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    redirectTo() {
      location.replace("/");
    },
  },
};
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #f8faf7;
  box-sizing: border-box;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  max-width: 420px;
  width: 100%;
  text-align: center;
}

/* ── Graphic ── */
.graphic-area {
  width: 100%;
  max-width: 280px;
}

.graphic-svg {
  width: 100%;
  height: auto;
  display: block;
}

/* ── Text area ── */
.text-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.badge {
  display: inline-block;
  background-color: #e8f2e5;
  color: #3a6b2e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 4px 14px;
  border-radius: 20px;
  font-family: "Courier New", monospace;
}

.heading {
  margin: 0;
  font-size: clamp(1.6rem, 6vw, 2.2rem);
  font-weight: 700;
  color: #1c2b19;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.subtext {
  margin: 0;
  font-size: 15px;
  color: #5a7354;
  line-height: 1.6;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  max-width: 320px;
}

/* ── Button ── */
.home-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 13px 28px;
  background-color: #519043;
  color: #fff;
  border: none;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.15s ease,
    box-shadow 0.2s ease;
  box-shadow: 0 4px 14px rgba(81, 144, 67, 0.35);
  letter-spacing: 0.2px;
}

.home-btn:hover {
  background-color: #3f7234;
  box-shadow: 0 6px 20px rgba(81, 144, 67, 0.45);
  transform: translateY(-1px);
}

.home-btn:active {
  background-color: #335e29;
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(81, 144, 67, 0.3);
}

/* ── Mobile ── */
@media (max-width: 480px) {
  .not-found-page {
    padding: 32px 16px;
    align-items: flex-start;
    padding-top: 20vh;
  }

  .content-wrapper {
    gap: 24px;
  }

  .graphic-area {
    max-width: 220px;
  }

  .home-btn {
    width: 100%;
    justify-content: center;
    padding: 15px 20px;
  }
}
</style>
